import { isPlatformServer } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  PLATFORM_ID,
  inject,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { LogoComponent } from '../logo/logo.component';
import { StoreBadgesComponent } from '../store-badges.component';
import { NAV_LINKS, SITE_LOCALES } from '../nav-link';

@Component({
  selector: 'layout-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LogoComponent, RouterLink, StoreBadgesComponent],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  /**
   * Whether to render the closing ask above the footer.
   *
   * True on the landing page, which ends on a call to download. False on
   * /terms and /privacy, where a reader has come to check something and does
   * not need selling to on the way out.
   */
  readonly withCta = input(false);

  protected readonly navLinks = NAV_LINKS;
  protected readonly year = new Date().getFullYear();

  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);

  /** Home within the reader's locale, not the English root. */
  protected get homeHref(): string {
    if (isPlatformServer(this.platformId)) return '/';

    const lang = this.document.documentElement.lang;
    return SITE_LOCALES.find((l) => l.code === lang)?.path ?? '/';
  }
}
